<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-9 is-offset-3">
        <div class="level-right columns">
          <div class="column is-3 is-2-fullhd">
            <div class="card">
              <div class="card-content pd-10px">
                <p class="has-text-default">
                  {{ $t('rapprochementAchat.affectation') }}
                </p>
                <div class="level">
                  <div class="level-left mgt-5px">
                    <b-icon :icon="getIcon" :type="getType"></b-icon>
                  </div>
                  <div class="level-right">
                      <span class="mgl-30px has-text-weight-bold">
                        {{ getMontantAffecter | formatDevise }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-3 is-2-fullhd">
            <div class="card">
              <div class="card-content pd-10px">
                <p class="has-text-default">
                  {{$t('rapprochementAchat.resteAffectation') }}
                </p>
                <div class="level">
                  <div class="level-left">
                    <b-icon :icon="getIcon" :type="getType"></b-icon>
                  </div>
                  <div class="level-right">
                      <span class="mgl-30px has-text-weight-bold">
                        {{ getMontantRestant | formatDevise }}
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  name: 'montantRapprochement',
  props: {
    facture: {
      type: Object,
      required: true,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: true,
    },
    isVisualisation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    getMontantRestant() {
      return (calculArrondi(
        this.facture.montantHt - this.getMontantAffecter - this.getMontantAvoir));
    },
    getMontantAvoir() {
      const t = this.facture.avoirsAffectes
        .map(a => Math.abs(a.montantHt))
        .reduce((partialSum, a) => partialSum + a, 0);
      return t;
    },
    getMontantAffecter() {
      if (this.commandeAchatARapprocher.length === 0) return 0;
      return this.commandeAchatARapprocher
        .map((echeance) => echeance.montantAffecter)
        .reduce((a, b) => a + b);
    },
    getType() {
      if (this.getMontantRestant < 0) return 'is-warning';
      if (this.getMontantRestant === 0) return 'is-success';
      return '';
    },
    getIcon() {
      if (this.getMontantRestant < 0) return 'alert';
      if (this.getMontantRestant === 0) {
        return 'check-circle';
      }
      return '';
    },
  },
};
</script>

<style scoped>

</style>
